/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const CupWithPenAndRulerIconOutline = createIcon({
  displayName: 'CupWithPenAndRulerIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M4.5 6.91h4"></path>
        <path d="M4.5 10.137v-4.7l-5.187e-08-5.24186e-05c-.00108046-1.10649.893571-2.00512 2.00005-2.00895v0l-8.74228e-08 2.22045e-15c1.10457-4.82823e-08 2 .89543 2 2 0 0 0 1.77636e-15 0 1.77636e-15v0 4.577"></path>
        <polyline points="11.25,10 11.25,2 16,2 16,10"></polyline>
        <path d="M17 17h1.5l-1.09278e-07-3.55271e-15c1.38071 6.03528e-08 2.5-1.11929 2.5-2.5v-1.445 0c0-1.10457-.895431-2-2-2h-2.167"></path>
        <path d="M5 10h10.833l-4.37114e-08 1.77636e-15c.552285-2.41411e-08 1 .447715 1 1v6.333l7.10543e-15 1.80063e-07c0 2.02484-1.64116 3.66645-3.666 3.667h-5.5l1.97134e-08 3.55271e-15c-2.02523-8.85255e-08-3.667-1.64177-3.667-3.667v-6.333l1.19904e-14 1.50996e-07c-8.33927e-08-.552285.447715-1 1-1Z"></path>
        <line x1="15.25" x2="13.75" y1="4.84" y2="4.84"></line>
        <line x1="15.25" x2="14.75" y1="7.34" y2="7.34"></line>
      </g>
    </>
  ),
})

const CupWithPenAndRulerIconTwoTone = createIcon({
  displayName: 'CupWithPenAndRulerIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          d="M4.5 10.137v-4.7l-5.187e-08-5.24186e-05c-.00108046-1.10649.893571-2.00512 2.00005-2.00895v0l-8.74228e-08 2.22045e-15c1.10457-4.82823e-08 2 .89543 2 2 0 0 0 1.77636e-15 0 1.77636e-15v0 4.577"
        ></Box>
        <Box as="path" stroke="twoToneStrokeColor" d="M4.5 6.91h4"></Box>

        <Box as="polyline" fill="twoToneLightColor" stroke="twoToneStrokeColor" points="11.25,10 11.25,2 16,2 16,10"></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          d="M17 17h1.5l-1.09278e-07-3.55271e-15c1.38071 6.03528e-08 2.5-1.11929 2.5-2.5v-1.445 0c0-1.10457-.895431-2-2-2h-2.167"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          d="M5 10h10.833l-4.37114e-08 1.77636e-15c.552285-2.41411e-08 1 .447715 1 1v6.333l7.10543e-15 1.80063e-07c0 2.02484-1.64116 3.66645-3.666 3.667h-5.5l1.97134e-08 3.55271e-15c-2.02523-8.85255e-08-3.667-1.64177-3.667-3.667v-6.333l1.19904e-14 1.50996e-07c-8.33927e-08-.552285.447715-1 1-1Z"
        ></Box>
        <Box as="line" stroke="twoToneStrokeColor" x1="15.25" x2="13.75" y1="4.84" y2="4.84"></Box>
        <Box as="line" stroke="twoToneStrokeColor" x1="15.25" x2="14.75" y1="7.34" y2="7.34"></Box>
      </g>
    </>
  ),
})

const CupWithPenAndRuler: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    case 'twoTone':
      return <CustomIcon as={CupWithPenAndRulerIconTwoTone} {...props} />
    default:
      return <CustomIcon as={CupWithPenAndRulerIconOutline} {...props} />
  }
}

export default memo(CupWithPenAndRuler)
